import { formatTimestampFull } from "@@common";
import { formatDate } from "../../../common/formatDate";
import { PropertyDisplayFormat } from "../../Models/PropertyDisplayFormat";
import { isEmptyDate } from "./formatPropertyValue";
import getCurrencyFormatter from "../../../common/getCurrencyFormatter";

/**
 * Formats a value based on the specified format and options
 */
export default function formatValue(value: any, format: PropertyDisplayFormat | undefined, currencyCode?: string): string {
    switch (format) {
        case PropertyDisplayFormat.Date:
            return isEmptyDate(value) ? "" : formatDate(value);
        case PropertyDisplayFormat.DateTime:
            return isEmptyDate(value) ? "" : formatTimestampFull(value);
        case PropertyDisplayFormat.Currency: {
            const code = currencyCode || "USD";
            const numericValue = typeof value === "number" ? value : parseFloat(value);

            if (isNaN(numericValue)) {
                return value;
            }

            const formatter = getCurrencyFormatter(code);
            return formatter.format(numericValue);
        }
        default:
            return value;
    }
}
